import { BookOpenText } from 'lucide-react';

const notes = [
  {
    title: 'Review cadence',
    body: 'Static MVP note: compare cash deployment and offensive budget after each fresh broker snapshot.'
  },
  {
    title: 'Data discipline',
    body: 'Treat broker fallback values as operational, not tick-level live pricing.'
  },
  {
    title: 'Next buildout',
    body: 'Wire persisted review notes before presenting this area as generated analysis.'
  }
];

export function AnalysisJournal() {
  return (
    <section className="dashboard-panel journal-panel" aria-labelledby="journal-heading">
      <div className="panel-heading">
        <div>
          <h2 id="journal-heading">Analysis journal</h2>
          <p>Static operating notes for the MVP dashboard.</p>
        </div>
        <BookOpenText size={18} aria-hidden="true" />
      </div>

      <ol className="journal-list">
        {notes.map((note) => (
          <li key={note.title}>
            <strong>{note.title}</strong>
            <p>{note.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
